module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    ref: "header",
    staticClass: "mobile-header is-mobile-flex"
  }, [_c('div', {
    staticClass: "header-left",
    on: {
      "click": function($event) {
        _vm.toggleMobileSidebar()
      }
    }
  }, [_c('h1', {
    staticClass: "site-title"
  }, [_c('svg-icon', {
    ref: "icon",
    staticClass: "svg-icon",
    attrs: {
      "name": "menu"
    }
  }), _vm._v(" "), (!_vm.config.disableHeaderTitle) ? _c('span', [_vm._v(_vm._s(_vm.config.title))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('header-icons', {
    attrs: {
      "current-icons": _vm.currentIcons
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-fbef0fec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileHeader.vue
// module id = 110
// module chunks = 0